import type { NavBadge } from '@/shell/module-system'
import { useDocRequestsBadge } from '@/shell/services/regulatory/api/doc-requests'

/** Sidebar count: vendor document requests the vendor has submitted, waiting to be attached (2026-10-12). */
export function useRegulatoryVendorNavBadge(): NavBadge | null {
  const { data } = useDocRequestsBadge()
  const n = data?.docs_received ?? 0
  return n ? { count: n, tone: 'warning', title: `${n} vendor document ${n === 1 ? 'request' : 'requests'} to review` } : null
}
